import React from 'react';
import { Link } from 'react-router-dom';
import { BaseModal } from './BaseModal';

interface AdPreferencesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AdPreferencesModal({ isOpen, onClose }: AdPreferencesModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Ad Preferences"
    >
      <div className="space-y-4 text-gray-600 dark:text-gray-300">
        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-xl p-4 mb-6">
          <p className="text-yellow-800 dark:text-yellow-200 text-sm">
            This is a test website for demonstration purposes only. The information below is an example of how advertising preferences might be managed.
          </p>
        </div>

        <p>
          We engage third-party advertisers to provide interest-based advertising on our website 
          and app, as well as other third-party websites and applications to display advertising 
          that is relevant to you. These third parties may collect information about your use of 
          our services over time and that information may be combined with information collected 
          on different online services.
        </p>

        <p>
          To learn more about interest-based advertising, or to opt out of having your web browsing 
          information used by certain third-party advertisers for behavioral advertising purposes, 
          go to:
        </p>

        <div className="space-y-2">
          <a 
            href="https://www.aboutads.info/choices" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#5e9bb8] hover:text-[#499da8] dark:text-[#5e9bb8] dark:hover:text-[#499da8] block transition-colors duration-200"
          >
            https://www.aboutads.info/choices
          </a>
          <a 
            href="https://www.networkadvertising.org/choices" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#5e9bb8] hover:text-[#499da8] dark:text-[#5e9bb8] dark:hover:text-[#499da8] block transition-colors duration-200"
          >
            https://www.networkadvertising.org/choices
          </a>
        </div>

        <div className="mt-6">
          <Link 
            to="/privacy"
            className="text-[#5e9bb8] hover:text-[#499da8] dark:text-[#5e9bb8] dark:hover:text-[#499da8] transition-colors duration-200"
            onClick={onClose}
          >
            For more information, please visit our Online Privacy & Security Policy page
          </Link>
        </div>
      </div>
    </BaseModal>
  );
}